import gql from "graphql-tag";

/**
 * companyUserSearchV2 — company-scoped, indexed user search for the event
 * attendee picker.
 *
 * The picker previously fetched the company's FULL user documents (and, with
 * "Add external users too", every user in the database — 15k full docs) and
 * filtered the array in the browser, so typing showed nothing until the whole
 * payload arrived. This returns ~25 projected rows in ~230 ms.
 *
 * Always scoped to one company on the server (deleted users excluded), so it is
 * safe for trainers — see backend `reports/search-users-v2.ts`.
 */
const companyUserSearchV2Query = gql`
  query companyUserSearchV2($companyId: String!, $term: String, $limit: Int) {
    companyUserSearchV2(companyId: $companyId, term: $term, limit: $limit) {
      users {
        _id
        firstName
        lastName
        email
        phone
        company {
          _id
          name
        }
      }
      total
    }
  }
`;

export default companyUserSearchV2Query;
